import styled from "styled-components";

const AdminTableViewport = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export default AdminTableViewport;
